// import { useEffect, useState } from "react";

// import MeetingApi from "../../api/MeetingApi";

// function MyMeetings() {
//   const [selectedMeeting, setSelectedMeeting] = useState(null);

//   const [showModal, setShowModal] = useState(false);

//   const [meetings, setMeetings] = useState([]);

//   const [showReschedule, setShowReschedule] = useState(false);

//   const [availableSlots, setAvailableSlots] = useState([]);

//   const [rescheduleData, setRescheduleData] = useState({
//     date: "",
//     time: "",
//   });

//   const openDetails = (meeting) => {
//     setSelectedMeeting(meeting);

//     setShowModal(true);
//   };

//   const cancelMeeting = async (id) => {
//     if (!window.confirm("Cancel Meeting?")) return;

//     await MeetingApi.cancel(id);

//     loadMeetings();

//     loadDashboard();
//   };

//   const completeMeeting = async (id) => {
//     await MeetingApi.complete(id);

//     loadMeetings();

//     loadDashboard();
//   };

// const openReschedule = async (meeting) => {    setSelectedMeeting(meeting);

//     const d = new Date(meeting.startTime);

//     setRescheduleData({
//       date: d.toISOString().split("T")[0],

//       time: d.toTimeString().slice(0, 5),
//     });

//   await loadSlots(
//   d.toISOString().split("T")[0],
//   meeting._id
// );

//     setShowReschedule(true);
//   };

//   const saveReschedule = async () => {
//     const meetingDateTime = `${rescheduleData.date}T${rescheduleData.time}`;

//     await MeetingApi.reschedule(selectedMeeting._id, {
//       meetingDateTime,
//     });

//     setShowReschedule(false);

//     loadMeetings();

//     loadDashboard();
//   };

//   const [stats, setStats] = useState({
//     today: 0,
//     upcoming: 0,
//     completed: 0,
//     cancelled: 0,
//   });

//   const loadMeetings = async () => {
//     const res = await MeetingApi.myMeetings();

//     if (res.code === 200) {
//       setMeetings(res.data);
//     }
//   };

//   const loadDashboard = async () => {
//     const res = await MeetingApi.dashboard();

//     if (res.code === 200) {
//       setStats(res.data);
//     }
//   };

// const loadSlots = async (date, meetingId) => {
//   const res = await MeetingApi.getSlots(
//     date,
//     meetingId
//   );

//   if (res.code === 200) {
//     setAvailableSlots(
//       res.data.filter((x) => x.available === 0)
//     );
//   }
// };

//   useEffect(() => {
//     loadMeetings();

//     loadDashboard();
//   }, []);

//   return (
//     <div className="content">
//       <div className="row mb-4">
//         <div className="col-lg-3">
//           <div className="card border-0 shadow-sm">
//             <div className="card-body">
//               <h6>Today's Meetings</h6>

//               <h2>{stats.today}</h2>
//             </div>
//           </div>
//         </div>

//         <div className="col-lg-3">
//           <div className="card border-0 shadow-sm">
//             <div className="card-body">
//               <h6>Upcoming</h6>

//               <h2>{stats.upcoming}</h2>
//             </div>
//           </div>
//         </div>

//         <div className="col-lg-3">
//           <div className="card border-0 shadow-sm">
//             <div className="card-body">
//               <h6>Completed</h6>

//               <h2>{stats.completed}</h2>
//             </div>
//           </div>
//         </div>

//         <div className="col-lg-3">
//           <div className="card border-0 shadow-sm">
//             <div className="card-body">
//               <h6>Cancelled</h6>

//               <h2>{stats.cancelled}</h2>
//             </div>
//           </div>
//         </div>
//       </div>

//       <div className="card">
//         <div className="card-header">
//           <h4>My Meetings</h4>
//         </div>

//         <div className="card-body">
//           <table className="table">
//             <thead>
//               <tr>
//                 <th>Client</th>

//                 <th>Date</th>

//                 <th>Time</th>

//                 <th>Status</th>

//                 <th>Actions</th>
//               </tr>
//             </thead>

//             <tbody>
//               {meetings.map((meeting) => (
//                 <tr key={meeting._id}>
//                   <td>{meeting.leadId?.name}</td>

//                   <td>{new Date(meeting.startTime).toLocaleDateString()}</td>

//                   <td>
//                     {new Date(meeting.startTime).toLocaleTimeString([], {
//                       hour: "2-digit",
//                       minute: "2-digit",
//                     })}
//                   </td>

//                   <td>
//                     <span
//                       className={`badge ${
//                         meeting.status === "scheduled"
//                           ? "bg-primary"
//                           : meeting.status === "completed"
//                             ? "bg-success"
//                             : "bg-danger"
//                       }`}
//                     >
//                       {meeting.status}
//                     </span>
//                   </td>

//                   <td>
//                     <div className="d-flex flex-wrap gap-2">
//                       {meeting.status === "scheduled" && (
//                         <a
//                           className="btn btn-success btn-sm"
//                           href={meeting.meetLink}
//                           target="_blank"
//                           rel="noreferrer"
//                         >
//                           Join
//                         </a>
//                       )}

//                       {meeting.status === "scheduled" && (
//                         <>
//                           <button
//                             className="btn btn-warning btn-sm"
//                             onClick={() => openReschedule(meeting)}
//                           >
//                             Reschedule
//                           </button>

//                           <button
//                             className="btn btn-danger btn-sm"
//                             onClick={() => cancelMeeting(meeting._id)}
//                           >
//                             Cancel
//                           </button>

//                           <button
//                             className="btn btn-secondary btn-sm"
//                             onClick={() => completeMeeting(meeting._id)}
//                           >
//                             Complete
//                           </button>
//                         </>
//                       )}
//                     </div>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       </div>

//       {showReschedule && (
//         <div
//           className="modal fade show"
//           style={{
//             display: "block",
//             background: "rgba(0,0,0,.45)",
//           }}
//         >
//           <div className="modal-dialog modal-dialog-centered">
//             <div
//               className="modal-content border-0 shadow-lg"
//               style={{
//                 borderRadius: 20,
//               }}
//             >
//               <div className="modal-header">
//                 <h4 className="fw-bold">📅 Reschedule Meeting</h4>

//                 <button
//                   className="btn-close"
//                   onClick={() => setShowReschedule(false)}
//                 />
//               </div>

//               <div className="modal-body">
//                 <div className="mb-3">
//                   <label className="form-label fw-semibold">Meeting Date</label>

//                   <input
//                     type="date"
//                     className="form-control"
//                     value={rescheduleData.date}
//                    onChange={async (e) => {

//   const value = e.target.value;

//   setRescheduleData({
//     ...rescheduleData,
//     date: value,
//     time: "",
//   });

// await loadSlots(
//   value,
//   selectedMeeting?._id
// );
// }}
//                   />
//                 </div>

//                 <div className="mb-3">
//                   <label className="form-label fw-semibold">Meeting Time</label>

//                   {/* <input
//                     type="time"
//                     className="form-control"
//                     value={rescheduleData.time}
//                     onChange={(e) =>
//                       setRescheduleData({
//                         ...rescheduleData,

//                         time: e.target.value,
//                       })
//                     }
//                   /> */}
//                   <select
//   className="form-select"
//   value={rescheduleData.time}
//   onChange={(e) =>
//     setRescheduleData({
//       ...rescheduleData,
//       time: e.target.value,
//     })
//   }
// >
//   <option value="">
//     Select Time
//   </option>

//   {availableSlots.map((slot) => (
//     <option
//       key={slot.time}
//       value={slot.time}
//     >
//       {slot.time}
//     </option>
//   ))}
// </select>
//                 </div>
//               </div>

//               <div className="modal-footer">
//                 <button
//                   className="btn btn-light"
//                   onClick={() => setShowReschedule(false)}
//                 >
//                   Cancel
//                 </button>

//                 <button className="btn btn-primary" onClick={saveReschedule}>
//                   Save Changes
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default MyMeetings;

import { useEffect, useState } from "react";

import MeetingApi from "../../api/MeetingApi";

function MyMeetings() {
  const [selectedMeeting, setSelectedMeeting] = useState(null);

  const [showModal, setShowModal] = useState(false);

  const [meetings, setMeetings] = useState([]);

  const [showReschedule, setShowReschedule] = useState(false);

  const [availableSlots, setAvailableSlots] = useState([]);

  const [rescheduleData, setRescheduleData] = useState({
    date: "",
    time: "",
  });

  // UI-only: lets us show a nice skeleton while the first load happens.
  // Does not change any existing API calls or logic.
  const [loading, setLoading] = useState(true);

  const openDetails = (meeting) => {
    setSelectedMeeting(meeting);

    setShowModal(true);
  };

  const cancelMeeting = async (id) => {
    if (!window.confirm("Cancel Meeting?")) return;

    await MeetingApi.cancel(id);

    loadMeetings();

    loadDashboard();
  };

  const completeMeeting = async (id) => {
    await MeetingApi.complete(id);

    loadMeetings();

    loadDashboard();
  };

  const openReschedule = async (meeting) => {
    setSelectedMeeting(meeting);

    const localDateTime = getLocalDateTime(meeting.startTime);

    setRescheduleData({
      date: localDateTime.date,
      time: localDateTime.time,
    });

    await loadSlots(localDateTime.date, meeting._id);

    setShowReschedule(true);
  };

  const saveReschedule = async () => {
    if (!selectedMeeting) {
      return;
    }

    if (!rescheduleData.date || !rescheduleData.time) {
      showToast("error", "Please select meeting date and time.");
      return;
    }

    try {
      const meetingDateTime = `${rescheduleData.date}T${rescheduleData.time}`;

      await MeetingApi.reschedule(selectedMeeting._id, {
        meetingDateTime,
      });

      setShowReschedule(false);
      setSelectedMeeting(null);

      await loadMeetings();
      await loadDashboard();

      showToast("success", "Meeting rescheduled successfully.");
    } catch (err) {
      console.error("Reschedule error:", err);

      showToast(
        "error",
        err?.response?.data?.message ||
          err?.message ||
          "Unable to reschedule meeting.",
      );
    }
  };
  const [stats, setStats] = useState({
    today: 0,
    upcoming: 0,
    completed: 0,
    cancelled: 0,
  });

  const loadMeetings = async () => {
    const res = await MeetingApi.myMeetings();

    if (res.code === 200) {
      setMeetings(res.data);
    }

    setLoading(false);
  };

  const loadDashboard = async () => {
    const res = await MeetingApi.dashboard();

    if (res.code === 200) {
      setStats(res.data);
    }
  };

  const loadSlots = async (date, meetingId) => {
    try {
      setAvailableSlots([]);

      if (!date) {
        return;
      }

      const res = await MeetingApi.getSlots(date, meetingId);

      if (res?.code === 200) {
        const slots = Array.isArray(res.data)
          ? res.data.filter((x) => x.available === 0)
          : [];

        setAvailableSlots(slots);

        return;
      }

      setAvailableSlots([]);

      showToast("error", res?.message || "Unable to load available slots.");
    } catch (err) {
      console.error("Load slots error:", err);

      setAvailableSlots([]);

      showToast(
        "error",
        err?.response?.data?.message ||
          err?.response?.data?.error ||
          err?.message ||
          "Unable to load available slots.",
      );
    }
  };

  const [toast, setToast] = useState({
    show: false,
    type: "",
    message: "",
  });

  const showToast = (type, message) => {
    setToast({
      show: true,
      type,
      message,
    });

    setTimeout(() => {
      setToast({
        show: false,
        type: "",
        message: "",
      });
    }, 3000);
  };
  useEffect(() => {
    loadMeetings();

    loadDashboard();
  }, []);

  const getLocalDateTime = (dateValue) => {
    const date = new Date(dateValue);

    const year = date.getFullYear();

    const month = String(date.getMonth() + 1).padStart(2, "0");

    const day = String(date.getDate()).padStart(2, "0");

    const hours = String(date.getHours()).padStart(2, "0");

    const minutes = String(date.getMinutes()).padStart(2, "0");

    return {
      date: `${year}-${month}-${day}`,
      time: `${hours}:${minutes}`,
    };
  };

  const getInitials = (name) => {
    if (!name) return "?";
    const parts = name.trim().split(" ");
    return (
      parts[0]?.[0]?.toUpperCase() +
      (parts.length > 1 ? parts[parts.length - 1][0]?.toUpperCase() : "")
    );
  };

  return (
    <div className="content">
      {toast.show && (
        <div className={`custom-toast ${toast.type}`}>
          <div className="toast-icon">
            {toast.type === "success" ? "✓" : "!"}
          </div>

          <div className="toast-content">
            <strong>{toast.type === "success" ? "Success" : "Error"}</strong>

            <span>{toast.message}</span>
          </div>

          <button
            className="toast-close"
            onClick={() =>
              setToast({
                show: false,
                type: "",
                message: "",
              })
            }
          >
            ×
          </button>
        </div>
      )}
      {/* ===================== STAT CARDS ===================== */}
      <div className="row modern-stat-row mb-4">
        <div className="col-lg-3 col-sm-6">
          <div className="card modern-stat-card stat-warning">
            <div className="stat-wave"></div>
            <div className="card-body">
              <div className="stat-top">
                <div>
                  <p>Today's Meetings</p>
                  <h3>{stats.today}</h3>
                </div>
                <div className="stat-icon">
                  <span style={{ fontSize: 22 }}>📅</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-3 col-sm-6">
          <div className="card modern-stat-card stat-info">
            <div className="stat-wave"></div>
            <div className="card-body">
              <div className="stat-top">
                <div>
                  <p>Upcoming</p>
                  <h3>{stats.upcoming}</h3>
                </div>
                <div className="stat-icon">
                  <span style={{ fontSize: 22 }}>⏳</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-3 col-sm-6">
          <div className="card modern-stat-card stat-success">
            <div className="stat-wave"></div>
            <div className="card-body">
              <div className="stat-top">
                <div>
                  <p>Completed</p>
                  <h3>{stats.completed}</h3>
                </div>
                <div className="stat-icon">
                  <span style={{ fontSize: 22 }}>✅</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-3 col-sm-6">
          <div className="card modern-stat-card stat-danger">
            <div className="stat-wave"></div>
            <div className="card-body">
              <div className="stat-top">
                <div>
                  <p>Cancelled</p>
                  <h3>{stats.cancelled}</h3>
                </div>
                <div className="stat-icon">
                  <span style={{ fontSize: 22 }}>❌</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ===================== MEETINGS TABLE ===================== */}
      <div className="card meetings-card-anim">
        <div className="card-header d-flex align-items-center justify-content-between">
          <h4 className="mb-0">My Meetings</h4>
          {!loading && meetings.length > 0 && (
            <span className="entries-text">
              {meetings.length} total meeting{meetings.length > 1 ? "s" : ""}
            </span>
          )}
        </div>

        <div className="card-body">
          {loading ? (
            <div>
              <div className="meeting-skeleton-row"></div>
              <div className="meeting-skeleton-row"></div>
              <div className="meeting-skeleton-row"></div>
            </div>
          ) : meetings.length === 0 ? (
            <div className="doc-empty-state">
              <div className="doc-empty-icon">📭</div>
              <div className="doc-empty-title">No meetings yet</div>
              <div className="doc-empty-subtitle">
                Scheduled meetings with your leads will show up here.
              </div>
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table meetings-table">
                <thead>
                  <tr>
                    <th>Client</th>
                    <th>Date</th>
                    <th>Time</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>

                <tbody>
                  {meetings.map((meeting, idx) => (
                    <tr
                      key={meeting._id}
                      className="meeting-row"
                      style={{ animationDelay: `${idx * 0.05}s` }}
                    >
                      <td>
                        <div className="meeting-client-cell">
                          <div className="meeting-avatar">
                            {getInitials(meeting.leadId?.name)}
                          </div>
                          <div>
                            <div className="meeting-client-name">
                              {meeting.leadId?.name}
                            </div>
                            <div className="meeting-client-label">Client</div>
                          </div>
                        </div>
                      </td>

                      <td>
                        {new Date(meeting.startTime).toLocaleDateString()}
                      </td>

                      <td>
                        {new Date(meeting.startTime).toLocaleTimeString([], {
                          hour: "2-digit",
                          minute: "2-digit",
                        })}
                      </td>

                      <td>
                        <span
                          className={`meeting-status-pill ${meeting.status}`}
                        >
                          <span className="meeting-status-dot"></span>
                          {meeting.status}
                        </span>
                      </td>

                      <td>
                        <div className="meeting-actions">
                          {meeting.status === "scheduled" && (
                            <a
                              className="meeting-btn join"
                              href={meeting.meetLink}
                              target="_blank"
                              rel="noreferrer"
                            >
                              🎥 Join
                            </a>
                          )}

                          {meeting.status === "scheduled" && (
                            <>
                              <button
                                className="meeting-btn reschedule"
                                onClick={() => openReschedule(meeting)}
                              >
                                🔄 Reschedule
                              </button>

                              <button
                                className="meeting-btn cancel"
                                onClick={() => cancelMeeting(meeting._id)}
                              >
                                ✖ Cancel
                              </button>

                              <button
                                className="meeting-btn complete"
                                onClick={() => completeMeeting(meeting._id)}
                              >
                                ✔ Complete
                              </button>
                            </>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>

      {/* ===================== RESCHEDULE MODAL ===================== */}
      {showReschedule && (
        <div
          className="modal fade show"
          style={{
            display: "block",
            background: "rgba(0,0,0,.45)",
          }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content reschedule-modal-content">
              <div className="modal-header reschedule-modal-header">
                <h4>📅 Reschedule Meeting</h4>

                <button
                  className="btn-close"
                  onClick={() => setShowReschedule(false)}
                />
              </div>

              <div className="modal-body reschedule-modal-body">
                <div className="reschedule-field">
                  <label>Meeting Date</label>

                  <input
                    type="date"
                    className="form-control reschedule-input"
                    min={new Date().toISOString().split("T")[0]}
                    value={rescheduleData.date}
                    onChange={async (e) => {
                      const value = e.target.value;

                      setRescheduleData({
                        ...rescheduleData,
                        date: value,
                        time: "",
                      });

                      await loadSlots(value, selectedMeeting?._id);
                    }}
                  />
                </div>

                <div className="reschedule-field mb-0">
                  <label>Meeting Time</label>

                  <select
                    className="form-select reschedule-select-input"
                    value={rescheduleData.time}
                    onChange={(e) =>
                      setRescheduleData({
                        ...rescheduleData,
                        time: e.target.value,
                      })
                    }
                  >
                    <option value="">Select Time</option>

                    {availableSlots.map((slot) => (
                      <option key={slot.time} value={slot.time}>
                        {slot.time}
                      </option>
                    ))}
                  </select>

                  {availableSlots.length === 0 && (
                    <div className="reschedule-slot-hint">
                      No slots loaded yet — pick a date to see available times.
                    </div>
                  )}
                </div>
              </div>

              <div className="modal-footer reschedule-modal-footer">
                <button
                  className="reschedule-cancel-btn"
                  onClick={() => setShowReschedule(false)}
                >
                  Cancel
                </button>

                <button
                  className="reschedule-save-btn"
                  onClick={saveReschedule}
                >
                  Save Changes
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default MyMeetings;
